import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import ReactGA from 'react-ga'
import { QUESTION_ORDER, QUESTION_ANALYTICS_NAMES } from '../../constants/QUESTIONS'
import Content from './Content/Content'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import JVLoader from './JVLoader/JVLoader'
import resizer from '../../../../shared/components/resizer'
import './Questions.scss'

// Only Re-render component when page changes or height changes
const checkRender = (prevProps, nextProps) => (
  (prevProps.page === nextProps.page) && (prevProps.rvh === nextProps.rvh)
)

const Questions = React.memo(({ rvh }) => {
  const currentQuestion = useSelector(state => state.questions.currentQuestion)
  const currentError = useSelector(state => state.questions.currentError)
  const slideDirection = useSelector(state => state.questions.slideDirection)
  const loading = useSelector(state => state.questions.loading)
  const totalPages = QUESTION_ORDER.length
  const currentIndex = QUESTION_ORDER.indexOf(currentQuestion)
  const currentPage = currentIndex + 1
  const handleAbandon = useCallback(() => {
    ReactGA.event({
      category: 'Form Field',
      action: 'Abandon',
      label: QUESTION_ANALYTICS_NAMES[currentQuestion]
    })
  }, [currentQuestion])

  useEffect(() => {
    window.addEventListener('beforeunload', handleAbandon)
    return () => {
      window.removeEventListener('beforeunload', handleAbandon)
    }
  }, [handleAbandon])

  return (
    <div
      className="q-container"
      style={{ height: `${rvh}px` }}
    >
      <JVLoader loading={loading} />
      <Header
        currentQuestion={currentQuestion}
        currentError={currentError}
      />
      <div
        id="q-content"
        className="content container"
      >
        <Content
          currentPage={currentPage}
          totalPages={totalPages}
          slideDirection={slideDirection}
          currentQuestion={currentQuestion}
          currentError={currentError}
        />
      </div>
      <div className="footer">
        <Footer
          currentQuestion={currentQuestion}
          currentError={currentError}
          currentIndex={currentIndex}
          questionOrder={QUESTION_ORDER}
        />
      </div>
    </div>
  )
}, checkRender)

Questions.displayName = 'Questions'

Questions.propTypes = {
  page: PropTypes.number.isRequired,
  rvh: PropTypes.number.isRequired
}

Questions.whyDidYouRender = true

export default resizer(Questions)
